window.TextArea = Backbone.View.extend({

    initialize: function(properties) {
        this.currentValue = properties.value || "";
        this.placeholder = properties.placeholder || "";
        this.rows = properties.rows || TextArea.DEFAULT_ROWS;
        this.maxLength = properties.maxLength || TextArea.DEFAULT_MAX_LENGTH;
        this.initialLength = this.currentValue.length;
        this.useCharCounter = properties.useCharCounter === true;
        this.required = properties.required === true;
        this.disabled = properties.disabled === true;

        this.render();
    },

    render: function() {
        var content = this.getContent();
        this.$el.html(content);

        this.$text = this.$el.find("textarea");
        this.$text.on("input", this.handleInput.bind(this));

        if(this.useCharCounter) this.$charCounter = this.$el.find(".char-counter-actual");
    },

    getContent: function() {
        return Handlebars.templates["ui/textarea"](this);
    },

    handleInput: function(e) {
        this.currentValue = this.limitTextArea(e.target, SkillsManager.MAX_NOTES_LENGTH);

        if(this.useCharCounter) this.$charCounter.text(e.target.value.length);
    },

    limitTextArea: function(target, limit) {
      var val = target.value;
      if(val.length > limit) {
        var old = this.currentValue;
        var from = 0;
        var to = target.selectionStart;

        while (old[from] === val[from]) from++;

        if(from + val.length - old.length > to) { // handle duplicates
          from = to - val.length + old.length;
        }

        var insert = val.substring(from, to);
        var end = val.substring(to, val.length);
        var insertLimit = limit - from - end.length;
        target.value = val.substring(0, from) + insert.substring(0, insertLimit) + end;
        target.selectionStart = target.selectionEnd = from + insertLimit;
      }

      return target.value;
    },

    getValue: function() {
        return this.currentValue;
    },

    setValue: function(value) {
        this.currentValue = value;
        this.$text.val(value);
    },

    isDisabled: function() {
        return this.disabled;
    },

    toggleDisabled: function(disabled) {
        this.disabled = disabled;
        this.$text.prop("disabled", disabled);
    },

    isRequired: function() {
        return this.required;
    },

    toggleRequired: function(required) {
        this.required = required;
        this.$text.attr("required", required);
    },

    isValid: function() {
        return this.$text[0].validity.valid;
    },

    destroy: function() {
        this.$text.off("input");
        this.remove();
    }
},
{
    DEFAULT_ROWS: 4,
    DEFAULT_MAX_LENGTH: 500
});
